import { action } from 'easy-peasy';

import { IActionSetClientDocumentsFilter } from '../types';

const setClientDocumentsFilter: IActionSetClientDocumentsFilter = action((state, payload) => {
  state.documents.filters = { ...state.documents.filters, ...payload };
});

export default setClientDocumentsFilter;
